import React from 'react';
import { translate } from 'react-i18next';
import FiltersViewGeneric from '@common/components/src/common/components/filters/FiltersView';

export const FiltersView = (props) => {
    return <FiltersViewGeneric {...props} />
}

export default (translate('common')(FiltersView));
